import {getTracerModules} from '@tracer/sdk';
import {tryRecoverFromError} from '@utils/tracer/recoverableError';
import {useEffect} from 'react';

export const useReportErrorFromBoundary = (error: Error, digest?: string) => {
  useEffect(() => {
    if (tryRecoverFromError(error)) {
      return;
    }
    let errorForReport = error;
    if (digest) {
      // репортим тут кастомную ошибку,
      // потому что у полученной ошибки нет стактрейса
      // и трейсер ее свалит иначе в общую кучу
      errorForReport = new Error(
        `An error occurred in the Server Components render on route ${document.location.pathname}${document.location.search}`,
      );
      error.name = 'ServerSideError';
    }
    getTracerModules().error?.error(errorForReport, {
      keys: {
        fromErrorBoundary: true,
        digest: digest || '',
        query: document.location.search,
      },
      type: 'CRASH',
    });
  }, [error, digest]);
};
